import React, { memo } from 'react'
import { useSetRecoilState } from 'recoil' 
import {
  currentSection as currentSectionState,
  selectedService as selectedServiceState,
  currentFix as currentFixState,
  lastSection as lastSectionState,
  currentSection,
} from '../../store/uiStore'
import { LogoWhite } from '../../assets/svg/icons'
import { ServiceLogoContainer } from '../../styles/servicesStyles'

const ServiceLogo = () => {
  const setCurrentSection = useSetRecoilState(currentSectionState)
  const setSelectedService = useSetRecoilState(selectedServiceState)
  const setLastSection = useSetRecoilState(
    lastSectionState
  )
  const setCurrentFix = useSetRecoilState(
    currentFixState
  )

  const handleGoToHome = () => {
    setLastSection((last) => currentSection)
    setSelectedService((last) => -1)
    setCurrentSection((last) => 'quienes-somos')
    setCurrentFix((last) => 'quienes-somos')
  }
  return (
    <ServiceLogoContainer onClick={() => handleGoToHome()}>
      <LogoWhite />
    </ServiceLogoContainer>
  )
}

export default memo(ServiceLogo)
